import React from "react"
import {
  UC_CUSTOMER_APPS_URL,
  UC_INTERNAL_BI_URL,
  UC_INTERNAL_TOOLING_URL,
} from "constants/urls"
import { usePageAssets } from "hooks/usePageAssets"
import ColumnDarkItem from "components/ui/ColumnDarkItem"
import Heading from "components/ui/Heading"
import DarkSection from "components/ui/Layout/DarkSection"

function UseCasesSection() {
  const { getAsset } = usePageAssets()
  const internalBiIllustration = getAsset("home-internal-bi-illustration")
  const internalToolsIllustration = getAsset("home-internal-tools-illustration")
  const customerAppsIllustration = getAsset("home-customer-apps-illustration")
  const divider = getAsset("home-divider-svg")
  return (
    <DarkSection className="py-16 md:pb-40 md:pt-24">
      <Heading
        label="Use Cases"
        title="Give data to anyone, anywhere"
        subtitle={
          <>
            Empower every team to be data-driven with our powerful business
            intelligence tool, unlocking valuable insights from beautiful and
            interactive dashboards. Or, quickly build interactive analytics
            native to internal tools and customer applications, saving time and
            engineering overhead.
          </>
        }
        decoration="border"
        inverted
      />
      <div className="mt-14 flex flex-col justify-between md:flex-row lg:mt-36">
        <ColumnDarkItem
          image={internalBiIllustration}
          imageClassName="h-56 lg:h-64"
          title="Explore in our BI tool"
          linkText="Explore BI Features"
          linkUrl={UC_INTERNAL_BI_URL}
          trackClick="Explore BI Features_Home"
          textAlign="center"
        />
        <img
          className="mx-auto w-1 rotate-90 md:w-auto md:rotate-0"
          src={divider.url}
          alt="Divider"
        />
        <ColumnDarkItem
          image={internalToolsIllustration}
          imageClassName="h-56 lg:h-64"
          title="Embed in internal tools"
          linkText="Explore Internal Tooling"
          trackClick="Explore Internal Tooling_Home"
          linkUrl={UC_INTERNAL_TOOLING_URL}
          textAlign="center"
        />
        <img
          className="mx-auto w-1 rotate-90 md:w-auto md:rotate-0"
          src={divider.url}
          alt="Divider"
        />
        <ColumnDarkItem
          image={customerAppsIllustration}
          imageClassName="h-56 lg:h-64"
          title="Build customer apps"
          linkText="Explore Customer Apps"
          linkUrl={UC_CUSTOMER_APPS_URL}
          trackClick="Explore Customer Apps_Home"
          textAlign="center"
        />
      </div>
    </DarkSection>
  )
}

export default UseCasesSection
